import React, { Component } from 'react';

class Navigator extends Component {
   constructor(){
      super();
   }
   componentWillReceiveProps(){
      this.setNavigationPosition();
   }
   setNavigationPosition(){
      // on mobile check if horizontal navigation overflows the screen
      // and reposition accordingly
      const screenWidth = this.navbar.clientWidth;
      const navWidth = this.navbar.scrollWidth;
      const overflow = this.navbar.scrollWidth - this.navbar.clientWidth;
      try{
         this.navbar.scrollBy(overflow, 0);
      }catch(e){}
   }
   render() {
      const {navBack, navigator, zoomLevel} = this.props;
      return(
         <div className="ep19-map-navigator" ref={(el)=>this.navbar=el}>
          {navigator.circoscrizione && 
         <span className='clickable' onClick={()=>navBack(0,navigator.circoscrizione)}> Circoscrizioni </span>
         }
         {navigator.circoscrizione && 
         <span> &raquo;&nbsp;
            <span 
               className={navigator.regioni && 'clickable'}  
               onClick={()=>navBack(1, navigator.circoscrizione)}>
               {navigator.circoscrizione} 
            </span>
         </span>
         }
         {navigator.regioni && 
         <span> &raquo;&nbsp;  
           <span>
            {navigator.regioni} 
            </span>
         </span>
         }
      </div>
      )
   }
}

export default Navigator;



// WEBPACK FOOTER //
// ./src/components/Navigator.js